var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadgallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3182,
    y: 1.15473,
    width: 54.3587,
    height: 54.3587,
    rx: 14.7888,
    transform: "rotate(0.172581 1.3182 1.15473)",
    fill: "black",
    stroke: "url(#paint0_linear_5454_13057)",
    strokeWidth: 2.39818
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8686 33.5391C32.7432 33.6962 32.7323 33.6393 32.62 33.7582C32.5865 33.7937 32.5588 33.85 32.5231 33.8857C32.4742 33.9347 32.4122 33.965 32.3481 34.0072C31.0599 34.9636 30.1881 36.3387 27.9713 35.912C27.2259 35.7686 26.8747 35.5482 26.367 35.1218C25.6098 34.4857 24.7907 33.8859 23.5857 33.8654C21.9534 33.8378 20.6542 35.0337 19.2583 35.9577C18.6216 36.3791 17.987 36.797 17.3431 37.2289L15.9051 38.1793C15.7035 38.3061 15.6039 38.4223 15.3665 38.5132C15.0273 36.8372 14.8289 37.2764 14.8377 34.915L14.8756 22.3352C14.8798 20.947 14.9125 19.8972 15.3296 18.6426C15.5224 18.0629 15.7309 17.6764 16.0252 17.2325C16.8994 15.9137 18.2283 15.1414 19.9198 14.8094C21.1698 14.5641 22.619 14.6385 23.9269 14.6425C26.7156 14.6509 29.5042 14.6593 32.2929 14.6677C34.7968 14.6752 37.8125 14.4308 39.7358 15.6458C39.9616 15.7884 40.1705 15.8919 40.351 16.0577C40.9558 16.6139 41.3215 16.9188 41.7661 17.7697C42.9041 19.9475 42.6068 22.7867 42.5991 25.3217C42.595 26.7113 42.6182 28.1299 42.5818 29.5154C41.7487 28.9796 41.1549 28.4219 39.6578 28.5758C39.1005 28.6331 38.6563 28.8055 38.2098 29.0496C37.8006 29.2734 35.5456 31.2761 34.9811 31.7365C34.8805 31.8185 34.8198 31.8493 34.7273 31.9389C34.1381 32.5096 33.507 32.9864 32.8685 33.539L32.8686 33.5391ZM12.3881 35.8184C12.4558 39.1776 13.842 42.1111 16.7734 43.6962C17.6255 44.1569 18.7541 44.5096 19.8491 44.6782C21.4043 44.9177 26.0267 44.8422 27.8768 44.8478C30.5569 44.8559 33.3502 44.9407 36.0167 44.8612C40.9589 44.7139 44.1901 41.9347 44.8731 37.4069C45.0682 36.1133 45.027 34.7959 45.031 33.4691C45.0428 29.5556 45.1516 25.0185 45.0581 21.244C44.9347 16.2662 42.1172 13.0628 37.6074 12.3728C36.3203 12.1758 34.9892 12.2176 33.6665 12.2136C29.7196 12.2018 25.28 12.103 21.4429 12.186C19.9082 12.2192 17.8461 12.6541 16.5687 13.4376C15.9617 13.8099 15.8773 13.9024 15.3673 14.2879C13.8981 15.3988 12.8661 17.6491 12.575 19.6403C12.3836 20.9488 12.419 22.2383 12.415 23.5801C12.403 27.5485 12.3102 31.9446 12.3883 35.8184L12.3881 35.8184Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.487 16.542C20.1933 16.8907 18.2842 18.9181 18.6619 21.6359C18.7455 22.2377 18.9623 22.8189 19.2517 23.2714C19.4508 23.5828 19.4544 23.6577 19.7015 23.9346C21.6511 26.1191 25.1225 25.8563 26.6074 23.758C27.2747 22.815 27.7693 21.803 27.5318 20.2839C27.1908 18.103 25.1018 16.1445 22.487 16.5419L22.487 16.542Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9051 34.8506C32.979 34.8019 33.0507 34.7669 33.1071 34.7103C33.1482 34.6692 33.1802 34.6041 33.2188 34.5632C33.3484 34.426 33.3611 34.4917 33.5057 34.3104C33.2745 34.4447 33.3644 34.384 33.1747 34.5844C33.0692 34.6958 33.1315 34.6214 33.0348 34.7084C32.8929 34.8362 32.9886 34.7286 32.9051 34.8506Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5454_13057",
    x1: 27.052,
    y1: 0.469862,
    x2: 28.9395,
    y2: 57.7258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA904E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D63BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadgallery);
export default __webpack_public_path__ + "static/media/uploadgallery.dfbaa4a61a59efc9432afb25e815d2c9.svg";
export { ForwardRef as ReactComponent };